import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-call.js";
import { f as e } from "../internals/function-uncurry-this-clause.js";
import { i as n } from "../internals/iterator-create-constructor.js";
import { c as s } from "../internals/create-iter-result-object.js";
import { r as i } from "../internals/require-object-coercible.js";
import { t as o } from "../internals/to-length.js";
import { t as a } from "../internals/to-string.js";
import { a as l } from "../internals/an-object.js";
import { i as m } from "../internals/is-null-or-undefined.js";
import { c as f } from "../internals/classof-raw.js";
import { i as p } from "../internals/is-regexp.js";
import { r as c } from "../internals/regexp-get-flags.js";
import { g } from "../internals/get-method.js";
import { d as u } from "../internals/define-built-in.js";
import { f as j } from "../internals/fails.js";
import { w as d } from "../internals/well-known-symbol.js";
import { s as x } from "../internals/species-constructor.js";
import { a as h } from "../internals/advance-string-index.js";
import { r as b } from "../internals/regexp-exec-abstract.js";
import { i as v } from "../internals/internal-state.js";
import { i as w } from "../internals/is-pure.js";
var E = d("matchAll"),
  R = "RegExp String",
  y = R + " Iterator",
  I = v.set,
  A = v.getterFor(y),
  S = RegExp.prototype,
  k = TypeError,
  q = e("".indexOf),
  F = e("".matchAll),
  O = !!F && !j(function () {
    F("a", /./);
  }),
  T = n(function (r, t, e, n) {
    I(this, {
      type: y,
      regexp: r,
      string: t,
      global: e,
      unicode: n,
      done: !1
    });
  }, R, function () {
    var r = A(this);
    if (r.done) return s(void 0, !0);
    var t = r.regexp,
      e = r.string,
      n = b(t, e);
    return null === n ? (r.done = !0, s(void 0, !0)) : (r.global ? "" === a(n[0]) && (t.lastIndex = h(e, o(t.lastIndex), r.unicode)) : r.done = !0, s(n, !1));
  }),
  _ = function _(r) {
    var t,
      e,
      n,
      s = l(this),
      i = a(r),
      m = x(s, RegExp),
      f = a(c(s));
    return t = new m(m === RegExp ? s.source : s, f), e = !!~q(f, "g"), n = !!~q(f, "u"), t.lastIndex = o(s.lastIndex), new T(t, i, e, n);
  };
r({
  target: "String",
  proto: !0,
  forced: O
}, {
  matchAll: function matchAll(r) {
    var e,
      n,
      s = i(this);
    if (m(r)) {
      if (O) return F(s, r);
    } else {
      if (p(r) && !~q(a(i(c(r))), "g")) throw k("`.matchAll` does not allow non-global regexes");
      if (O) return F(s, r);
      if (void 0 === (n = g(r, E)) && w && "RegExp" == f(r) && (n = _), n) return t(n, r, s);
    }
    return e = a(s), RegExp(r, "g")[E](e);
  }
}), E in S || u(S, E, _);